import { Component, Input } from '@angular/core';

@Component({
	selector: 'message-info-panel-item',
	templateUrl: 'message-info-panel-item.html'
})

export class MessageInfoPanelItemComponent {

	@Input('item') infoItem: any;
	@Input('userId') userId : any;


	constructor() {
	}

}



// WEBPACK FOOTER //
// ./src/components/message-info-panel-item/message-info-panel-item.ts